export default {
  introduce: 'Kilimall 商户中心',
  Bangladesh: '孟加拉站',
  Pakistan: '巴基斯坦站',
  Burma: '缅甸站',
  Laos: '斯里兰卡站',
  Nepal: '尼泊尔站',
  question: '常见问题'
}
